import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons'
import Vue from 'vue'
import mixin from '@/utils/mixin'
import BlogList from '@/components/blogs/BlogList'
import IndexBlogList from '@/components/blogs/IndexBlogList'
import RecommendBlogList from '@/components/blogs/RecommendBlogList'
import FloatActionButton from '@/components/blogs/FloatActionButton'

UIkit.use(Icons)
Vue.config.productionTip = false
import '@/blogs/blogs.scss'

new Vue({
    el: '#app',
    mixins: [mixin],
    components: { BlogList, RecommendBlogList, FloatActionButton, IndexBlogList },
    data() {
        return {}
    },
    methods: {},
    mounted() {},
    beforeDestroy() {},
})